export const PELICAN_AIR_SERVICES_SHIPPER_INFO = {
  companyName: "Pelican Air Services",
  contactName: "Jean Michel Ducros",
  phone: "+330637248961",
  email: "tracking@pelicanairservices.com",
  streetLines: ["25 Avenue du Perigord", "Eco Park Local 09"],
  city: "POMPIGNAC",
  stateOrProvinceCode: "",
  countryCode: "FR",
  postalCode: "33370",
  residential: false,
  taxId: "FR88255831500033",
};

export const PELICAN_AIR_SERVICES_ADDRESS = {
  streetLines: PELICAN_AIR_SERVICES_SHIPPER_INFO.streetLines,
  city: PELICAN_AIR_SERVICES_SHIPPER_INFO.city,
  postalCode: PELICAN_AIR_SERVICES_SHIPPER_INFO.postalCode,
  countryCode: PELICAN_AIR_SERVICES_SHIPPER_INFO.countryCode,
  stateOrProvinceCode: PELICAN_AIR_SERVICES_SHIPPER_INFO.stateOrProvinceCode,
};
